import { createContext, useContext } from 'react';

// The business entity a page shows master data contents within (`mission:<id>`): the back lets
// their images be read there by the users reading the mission, see `withFileReadContext`.
const FileReadContext = createContext<string | undefined>(undefined);

export const FileReadContextProvider = FileReadContext.Provider;

export const useFileReadContext = () => useContext(FileReadContext);
